import { ProviderTypeEnum } from '../../enums/provider-type.enum';

export class Provider{
    Id: number;
    ProviderType? : ProviderTypeEnum;
    ProviderTypeName? : string;
    Name?:string;
    Description?: string;
    ConnectionString?:string;
    Revision?: number;
}
